export default __webpack_public_path__ + "static/banner-4ea46ca4526c4966c3ee57ea1393d609.png";